// API 配置
// 直接使用 .env.production 中配置的 API URL
const ENV_PRODUCTION_API_URL = 'https://reservation-api.51min.win';

// 开发环境使用环境变量，生产环境使用 .env.production 中的值
export const API_BASE_URL = 
  process.env.NODE_ENV === 'development' 
    ? (process.env.REACT_APP_API_URL || window.location.origin)
    : ENV_PRODUCTION_API_URL;

// 调试信息
console.log('[Config] Environment:', process.env.NODE_ENV);
console.log('[Config] API_BASE_URL:', API_BASE_URL);
console.log('[Config] window.location.origin:', window.location.origin); 